import {useEffect, useState} from 'react'
import {Modal, Button, Form} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'

interface Props {
  show: boolean
  onClose: () => void
  onSave: (text: string) => void
}

export const ModalAddComment: React.FC<Props> = ({show, onClose, onSave}) => {
  const intl = useIntl()
  const [text, setText] = useState('')

  const handleSave = () => {
    if (!text.trim()) return
    onSave(text.trim())
    setText('')
  }

  useEffect(() => {
    if (!show) setText('')
  }, [show])

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='leads.kanban.addComment' defaultMessage='Add comment' /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label><FormattedMessage id='common.field.comment' defaultMessage='Comment' /></Form.Label>
          <Form.Control
            as='textarea'
            rows={4}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={intl.formatMessage({id: 'leads.kanban.commentPlaceholder', defaultMessage: 'Enter your comment here'})}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='light' onClick={onClose}>
          <FormattedMessage id='common.action.cancel' defaultMessage='Cancel' />
        </Button>
        <Button variant='primary' onClick={() => {handleSave(); onClose()}} disabled={!text.trim()}>
          <FormattedMessage id='common.action.save' defaultMessage='Save' />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
